import React from 'react';
import { Box } from '@mui/material';


import { makeStyles } from 'tss-react/mui';


const useContentStyles = makeStyles()(theme => ({
  content: {
    paddingRight: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  topSpacing: {
    paddingTop: theme.spacing(1),
  },
  bottomSpacing: {
    paddingBottom: theme.spacing(1),
  },
  leftSpacing: {
    paddingLeft: theme.spacing(4),
  },
}));


export const ServerFormSection: React.FC<{ raw?: boolean; topSpacing?: boolean; bottomSpacing?: boolean; leftSpacing?: boolean }> = ({ topSpacing = true, bottomSpacing = true, leftSpacing = true, ...props }) => {
  const { classes, cx } = useContentStyles();


  if (props.raw) {
    return (
      <Box>
        {props.children}
      </Box>
    );
  }

  return (
    <Box
      className={cx(
        classes.content, {
          [classes.topSpacing]: topSpacing,
          [classes.bottomSpacing]: bottomSpacing,
          [classes.leftSpacing]: leftSpacing
        })}
    >
      {props.children}
    </Box>
  );
};


const useGreyContentStyles = makeStyles()(theme => ({
  content: {
    paddingRight: theme.spacing(4),
    backgroundColor: theme.palette.grey[50],
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  topSpacing: {
    paddingTop: theme.spacing(1.5),
  },
  bottomSpacing: {
    paddingBottom: theme.spacing(1.5),
  },
  leftSpacing: {
    paddingLeft: theme.spacing(4),
  }
}));


export const ServerFormSectionGrey: React.FC<{ raw?: boolean; topSpacing?: boolean; bottomSpacing?: boolean; leftSpacing?: boolean }> = ({ topSpacing = true, bottomSpacing = true, leftSpacing = true, ...props }) => {
  const { classes, cx } = useGreyContentStyles();

  if (props.raw) {
    return (
      <Box>
        {props.children}
      </Box>
    );
  }

  return (
    (
      <Box
        className={cx(
          classes.content, {
            [classes.topSpacing]: topSpacing,
            [classes.bottomSpacing]: bottomSpacing,
            [classes.leftSpacing]: leftSpacing
          })}
      >
        {props.children}
      </Box>
    )
  );
};
